module.exports = __webpack_public_path__ + "static/media/sx.78876392.svg";